import React, {

  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {  useTranslation } from 'react-multi-lang';
import './orders.scss';
import { PrintDeliveryOrder } from '../../components/print/print_delivery_order';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { ordersSlice, ordersState } from './OrdersSlice';


import {

  Launch,
  BuildCircle,
  CarCrash,
  MonetizationOn,
} from '@mui/icons-material';
// API
import  { Iprintdeliverynote, iStatusOperation, order, sortDirectionType, storeOrder } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import { Confirm } from '../../components/Alerts/Alerts';

import { havePermission } from '../../services/hoc/permissions';
import {  useLocation, useNavigate } from 'react-router-dom';
import SettingContext from '../../services/context/setting-contentxt/setting-context';
import { PrintOrder } from '../../components/print/print_order';
import { Wait } from '../../components/wait';
import { IconButton } from '../../components/icon-button';
import { useNotification } from '../../services/usenotification';

import { Tooltip } from '@mui/material';
import {  AxiosError, AxiosResponse } from 'axios';
import OperationStatus from '../../components/OrderStatus/orderStatus';
import OrderStatusMenu from '../../components/OrderStatusMenue/OrderStatusMenu';
import { getListSort } from '../../services/hoc/sort';
import { RowContainer } from '../../components/Table/row_container';
import { SortTable } from '../../components/Table/SortTable';
import { PrintPrices } from '../../components/print/print_prices';
import { StatisticStatusFilter } from '../../components/Filters/status_filter';
import { calculate_single_price, calculate_total_price, total_price_calculator } from '../Order/common';
import { useCookies } from 'react-cookie';
import { useAPI } from '../../services/hoc/useAPI';

const Orders =  () => {
  // Translation
  const t = useTranslation();
  const { isPc } = useContext(SettingContext);
  const keyword_ref=useRef<string|null>(null)

  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  const [deliveryOrderPrint, setDeliveryOrderPrint] = useState<{open?:boolean,data?:Iprintdeliverynote}>();
 
  const [printOrder, setPrintOrder] = useState({ open: false, data: {} });
  const [wait, setWait] = useState(false);
  const[printPricse,setPrintPrices]=useState<{open:boolean,data?:storeOrder}>({open:false})
  // Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [cookie] =useCookies()
  const { alertError500 ,alert } = useNotification();
  const sort_fields = useRef<{sort_field?:number,sort_direction?:sortDirectionType}>({})

  const state = useSelector((state: { orders: ordersState }) => state.orders);

  const [showFilter , setShowFilter] = useState(false)
  const [chosenFilter , setChosenFilter] = useState<iStatusOperation|null>()

  // Hooks

  const ENDPOINTS = useAPI()

  // Search
  const search = (value: string,filter_data?:boolean) => {
   if (!filter_data) dispatch(ordersSlice.actions.reset());
    keyword_ref.current=Boolean(value)?value:null
    fetchData(1,Boolean(value)? 20:8, value,filter_data);
  };



  // Fetch Data
  const fetchData =useCallback( (
    page: number,
    page_size: number = 10,
    keyword?: string,
    filter_data?:boolean,
    sort_direction?:sortDirectionType,
    sort_field?:number

  ) => {
    dispatch(ordersSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.orders()
      .index({ 
        page, 
        page_size
        , keyword
        , sort_direction
        ,sort_field 
      })
      .then((response: any) => {
        dispatch(ordersSlice.actions.setIsFetching(false));
        dispatch(ordersSlice.actions.setPage(pagesInfo.page));

        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        let orders: order[] = response.data.data.orders.map(
          (order: any): order => ({
            id: order.id,
            order_no: order.order_no,
            date: order.date,
            delivery_date: order.delivery_date,
            summary: order.summery,
            job_order_printed: order.job_order_printed === '1',
            client_id: order.client_id,
            delivery_order_issued: order.delivery_order_issued === '1',
            client_name: order.client_name,
            client_phone: order.client?.phone,
            job_order_date: order.job_order_date,
            invoice_issued: order.invoice_issued === '1',
            bill: order.client?.bill ? order.client.bill : null,
            orderstatus: order.orderstatus,
            bill_id: order.bill_id,
            glass_summary: order.glass_summary,
            glass_work_summary: order.glass_work_summary,
          }),
        );

        //dispatch(ordersSlice.actions.reset());
        
        if (filter_data) {
          
           dispatch(ordersSlice.actions.filterOrders(orders))
        }
          else {
        dispatch(ordersSlice.actions.initializeOrders(orders));
        }
        dispatch(
          ordersSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );
        if (!state.isLoaded) dispatch(ordersSlice.actions.setIsLoaded(true));
      });
  },[dispatch,ENDPOINTS,state.isLoaded,pagesInfo.page])

  const fetchSortedData =useCallback((sort_field:number,sort_direction:sortDirectionType)=>{
    if (sort_direction && sort_field){
         sort_fields.current.sort_direction=sort_direction 
      sort_fields.current.sort_field=sort_field

       if (chosenFilter && showFilter) {
        fetchData(state.page,8,chosenFilter.status,true,sort_direction,sort_field)

      }
      else {

        fetchData(state.page,8,'',false,sort_direction,sort_field)
      }
    }
  },[state.page,chosenFilter])



  const handleStaticFunction = (
    orderStatus: string,
    order_id = 0,
    bill_id = 0,
    orderStatus_code: number,
  ) => {
    return (
      <>
      {orderStatus_code>=2 &&
       (
           <IconButton
              DoIcon={<MonetizationOn sx={{color:'var(--primary-color)'}}/>}
              cancelTitle=''
              doTitle={t("order_review")}
              value={false}
              disabled={!havePermission("Print Job Order")}
             style={{margin:'0 5px'}}
              doFunction={()=>{
               {
                let res= ENDPOINTS.orders().show({id:order_id?order_id:0})

                .then((res:AxiosResponse<{data:order}>)=>{
                  if (res.data.data) {
                    let d = res.data.data
                    let data_prices:storeOrder={
                      client_id:-1,
                      date:d.date??'',
                      delivery_date:d.delivery_date??'',
                      glass_summary:d.glass_summary??'',
                      glass_work_summary:d.glass_work_summary??'',
                      order_no:d.order_no??'',
                      summary:d.summary??'',
                      client:d.client,
                      order_details:d.orderdetail?.map((ele,i)=>{
                      let min_area= ele.glass_work?.min_area??0
                      let unit= ele.glass_work?.unit??'Area'
                      let width = ele.width??0
                      let length = ele.length ??0
                      let price = ele.price??0
                      let total_price = total_price_calculator(width,length,ele.piece_count??0,price,min_area,unit)
                                  
                      return {
                        glass_code: ele.glass?.code ?? '',
                        glass_id: ele.glass_id ?? -1,
                        glass_work_id: ele.glass_work_id ?? -1,
                        glasswork_code: ele.glass_work?.code ?? '',
                        length: ele.length ?? 0,
                        piece_code: ele.piece_code ?? '',
                        piece_count: ele.piece_count?? 0,
                        single_price:0 ,
                        total_price,
                        price:price,
                        width: ele.width ?? 0,
                        serial_number: i,
                        area:ele.area,
                        glass:ele.glass,
                        glass_work:ele.glass_work

                      }
                      })

                    }
                    setPrintPrices(pre=>({data:data_prices,open:true}))
                  }
                  return true
                })
                .catch((err:any)=>
                {
              alertError500(err)
              return true
            }
                )
                return res
               }
              }}
               />)}
        {orderStatus_code >= 4 && (
          <IconButton
            DoIcon={<BuildCircle sx={{ color: 'var(--primary-color)' }} />}
            cancelTitle=""
            doTitle={t('print_job_order')}
            value={false}
            disabled={!havePermission('Print Job Order')}
            style={{ margin: '0 2px' }}
            doFunction={() => {
              {
                let res = ENDPOINTS.orders()
                  .printOrder({ id: order_id ? order_id : 0 })

                  .then((res: any) => {
                    if (res.data.data) {
                      setPrintOrder((pre) => ({
                        ...pre,
                        data: res.data.data,
                        open: true,
                      }));
                    }
                    else {
                      alert({en:"Job order can't be printed than once",ar:'لا يمكن طباعة أمر الشغل أكثر من مرة'},'warning')
                    }
                    return true;
                  })
                  .catch((err: any) => {
                    alertError500(err);
                    return true;
                  });
                return res;
              }
            }}
          />
        )}
        {orderStatus_code >= 6 && (
          <>
            <IconButton
              DoIcon={<CarCrash sx={{ color: 'var(--primary-color)' }} />}
              cancelTitle=""
              doTitle={t('print_delivery_order')}
              value={false}
              disabled={!havePermission('Print Delivery Order')}
              style={{ margin: '0 2px' }}
              doFunction={() => {
                {
                  let res = ENDPOINTS.bills()
                    .printDeliveryOrder({ id: bill_id ?? 0 })

                    .then((res) => {
                      if (res.data.data) {
                        setDeliveryOrderPrint((pre) => ({
                          ...pre,
                          data: res.data.data,
                          open: true,
                        }));
                      }
                      return true;
                    })
                    .catch((err: any) => {
                      alertError500(err);
                      return true;
                    });
                  return res;
                }
              }}
            />
          </>
        )}
        {orderStatus_code >= 3 && (
          <IconButton
            DoIcon={<Launch sx={{ color: 'var(--primary-color)' }} />}
            cancelTitle=""
            doTitle={t('show_invoice')}
            value={false}
            style={{ margin: '0 2px' }}
            doFunction={() => {
              {
                navigate(`/bills/${bill_id}`);
                return true;
              }
            }}
          />
        )}
      </>
    );
  };

  const orderStatus = (order: order) => (
    <div
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      style={{
        display: 'flex',
        justifyContent: 'space-center',
        alignItems: 'center',
        maxHeight:'30px'
      }}>
      <span style={{ marginInline: '5px' }}>
        {order && order.orderstatus && order.orderstatus.length > 0
          ? t(order.orderstatus[0].status)
          : ''}
      </span>
    </div>
  );
  const operation = (order: order) => (
    <div
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        maxHeight:'30px'
      }}>
      {order.orderstatus && order.orderstatus.length > 0 ? (
        order.orderstatus[0].status !== 'Open' 
        && (order.orderstatus[0].code ===5 || 
         order.orderstatus[0].code ===2)? (
          <OperationStatus
            disabled={
              !havePermission('Previous Status') 
            }
            style={{ margin: '0 2px' }}
            id={
              order.orderstatus.length > 0
                ? state.operationsStatus.filter(
                    (ele) =>
                      ele.status ===
                      (order.orderstatus && order.orderstatus[0]
                        ? order.orderstatus[0].status
                        : ''),
                  )[0]
                  ? state.operationsStatus.filter(
                      (ele) =>
                        ele.status === order.orderstatus?.[0].status &&
                        ele.function !== 'Show',
                    )[0].code
                  : -1
                : -1
            }
            fun={() => {
              let res = ENDPOINTS.orders()
                .previousStatus({
                  order_id: order.id ?? 0,
                  status: order.orderstatus ? order.orderstatus[0].status : '',
                })
                .then((res: any) => {
                  if (res.data.data) {
                    dispatch(ordersSlice.actions.updateOrder(res.data.data));
                  }
                  return true;
                })
                .catch((err: any) => {
                  alertError500(err);
                  return true;
                });
              return res;
            }}
          />
        ) : null
      ) : null}

      {order.orderstatus &&
      order.orderstatus[0] &&
      order.orderstatus[0].status !== 'Closed' ? (
        <OperationStatus
          disabled={!havePermission('Next Status')}
          next={true}
          id={
            state.operationsStatus
              .filter(
                (ele) =>
                  ele.status === order.orderstatus?.[0].status &&
                  ele.function !== 'Show',
              )
              .at(-1)?.code?? 0
          }
          fun={() => {
            let res = ENDPOINTS.orders()
              .nextStatus({
                order_id: order.id ?? 0,
                status: order.orderstatus ? order.orderstatus[0].status : '',
              })
              .then((res: any) => {
                if (res.data.data) {
                  dispatch(ordersSlice.actions.updateOrder(res.data.data));
                  if (
                    res.data.data &&
                    res.data.data.orderstatus &&
                    res.data.data.orderstatus.length > 0
                  ) {
                    if (
                      res.data.data.orderstatus[0].status === 'Invoice Issued'
                    ) {
                      navigate(`/bills/${res.data.data.bill_id}`);
                    }
                  }
                }
                return true;
              })
              .catch((err: any) => {
                alertError500(err);
                return true;
              });
            return res;
          }}
        />
      ) : null}
    </div>
  );

  const staticAction = (order: order) => (
    <div
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        maxHeight:'30px'
      }}>
      {order.orderstatus && order.orderstatus[0]
        ? handleStaticFunction(
            order.orderstatus[0].status,
            order.id,
            order.bill_id,
            order.orderstatus[0].code,
          )
        : null}
    </div>
  );
  const action = (order: order) => (
    <div
      className="show-on-hover"
      style={{ display: 'flex', alignItems: 'center',maxHeight:'30px' }}>
      {havePermission('Show Order') && (
        <>
          <Tooltip title={t('info')}>
            <i
              className="icon-info"
              onClick={() => {
              
                
                navigate(`/orders/${order.id}`);
              }}
            />
          </Tooltip>
        </>
      )}

      { false && havePermission('Delete Order') ? (
        <Tooltip title={t('delete')}
        
        >
          <i
            className="icon-delete"
            data-tip={t('delete-order')}
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(order.id),
              });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      <div onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <OrderStatusMenu
          status={
            order && order.orderstatus && order.orderstatus.length > 0
              ? order.orderstatus[0].status
              : ''
          }
          statusMenu={order.orderstatus ? order.orderstatus : []}
        />
      </div>
    </div>
  );

  const rows = () => {
    let list = Boolean(chosenFilter)?state.filteredOrders[state.page] :
     state.orders[pagesInfo.page] 
    return list
      ? list.map((order, index) => {
          return (
            <RowContainer
              key={index}
              item_id={order.id?.toString() as string}
              onSelect={toggleSelectedId}
              state_length={state.orders[state.page]?.length as number}
              tr_index={index}
              columns={
                isPc?
                [
                order.order_no,
                order.client_name,
                order.date?.replaceAll('-','/'),
                order.delivery_date?.replaceAll('-','/'),
                order && order.orderstatus && order.orderstatus.length > 0
                  ? order.orderstatus[0].status_date.split(' ')[0].replaceAll('-','/')
                  : '',
                orderStatus(order),
                operation(order),
                staticAction(order),
                action(order),
              ]:[

                order.order_no,
                order.client_name,
                order.date?.replaceAll('-','/'),
               
                orderStatus(order),
                operation(order),
                staticAction(order),
                action(order),
              ]
            }
            />
          );
        })
      : null;
  };
  // Toggle Selected id
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Order')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(ordersSlice.actions.setIsLoading(true));
    ENDPOINTS.orders()
      .delete({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(ordersSlice.actions.setIsLoading(false));
        dispatch(ordersSlice.actions.deleteOrders(ids));
      })
      .catch((err:AxiosError)=>{
        alertError500(err)
         dispatch(ordersSlice.actions.setIsLoading(false));
      })
  };
 
  const handleChosenFilter =(item:iStatusOperation|null)=>{
    //dispatch(ordersSlice.actions.filterOrders({option:item}))
    setChosenFilter(pre=>item)
    if (item) {
      search(item.status.toString(),true)
    }   
  }

  useEffect(() => {
    if (location.state) {
      if (!state.isFetching) {
        search(location.state.key)
      }
    } else {
      if (!state.isFetching) {
        fetchData(1,8,'',false,sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [location.state]);
  
  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        ordersSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page,8,'',false,sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [pagesInfo.page]);
  


  useEffect(() => {
    ENDPOINTS.orders()
      .statusOperations({ page: 1, page_size: 100 })
      .then((res: any) => {
        if (res.data && res.data.data && res.data.data.status_operations) {
          dispatch(
            ordersSlice.actions.setStatusOperations(
              res.data.data.status_operations,
            ),
          );
        }
      })
      .catch((err: any) => alertError500(err));
  }, []);
  
  useEffect(()=>{
    if (!showFilter || !chosenFilter)dispatch(ordersSlice.actions.resetFilter())
 
  },[showFilter,chosenFilter])

  //console.log(state)
  
  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}
          <TableActionBar
            keyword={location.state ? location.state.key : ''}
            title={t('orders')}
            search={search}
            showFilter={true}
            triggerFilter={()=>{

              setShowFilter(!showFilter)
              if (showFilter) handleChosenFilter(null)
             
            }
            }
            showDelete={selectedIds.length > 0}
            delete={() => {
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(),
              });
            }}
            addText={t('add_to_orders')}
            add={
              havePermission('Add Order')
                ? () => {
                    // ( document.getElementsByTagName('html'))[0].style.overflowY='hidden';
                    //dispatch(addOrderSlice.actions.setIsOpen(true))
                    navigate('/orders/add_order');
                  }
                : undefined
            }
          />
         
          <StatisticStatusFilter trigger={handleChosenFilter} open={showFilter} />
         
          <SortTable
            header={
              isPc?
              [
              t('order_no'),
              t('client_name'),
              t('order_date'),
              t('delivery_date'),
              t('order_status_date'),
              t('order_status'),

              t('operation'),
              '',
              '',
            ]:
            [
              t('order_no'),
              t('client_name'),
              t('order_date'),
            
              t('order_status'),

              t('operation'),
              '',
              '',
            ]
          }
            onSelect={toggleSelectedId}
            hasMore={state.hasMore}
            loadMore={() => {}}
            pagesInfo={pagesInfo}
            setPagesInfo={setPagesInfo}
            break_on_overflow={true}
            state={Boolean(chosenFilter)?state.filteredOrders[state.page] :(state.orders[state.page]??[])}
            sort_fields={getListSort(
              isPc?
              [
                'order_no',
                'client_name',
                'order_date',
                'delivery_date',
               
                'order_status_date',
                'order_status',
                'operations',
                '',
              ]:
              [
                'order_no',
                'client_name',
                
               
                'order_status_date',
                'order_status',
                'operations',
                '',
              ]
              ,
              'Orders',
            )}
            fetchSortedData={fetchSortedData}>
            <>{rows()}</>
          </SortTable>

          {/* <OrderDetail
            open={openOrderDetail}
            setOpen={setOpenOrderDetail}
            data={generateOrderDetail()}
          /> */}
       

          {wait && <Wait />}
          <div
            id="includeMe"
            style={{ position: 'absolute', visibility: 'hidden', zIndex: -1 }}>
            {deliveryOrderPrint?.open && (
              <PrintDeliveryOrder
                close={() =>
                  setDeliveryOrderPrint((pre) => ({ ...pre, open: false }))
                }
                data={deliveryOrderPrint.data}
              />
            )}
            {printOrder.open && (
              <PrintOrder
                close={() => setPrintOrder((pre) => ({ ...pre, open: false }))}
                data={printOrder.data}
              />
            )}
            {
          printPricse.open && (
            <PrintPrices 
            close={() => setPrintPrices((pre) => ({ ...pre, open: false }))}
            data={printPricse.data}
            setWait={setWait}
            tax_percent={cookie?.company_info?.tax_percent}
            />
          )
        }
          </div>
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
export default Orders;